import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { LeaveTypeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  types: LeaveTypeFragment[]
}

const ArchivedLeaveTypes = ({ types }: Props) => {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Box paddingY="s32" flexDirection="row" gap="s12">
        <Text.Normal weight="medium">
          {i18n.t('settings.leave_types.list.archived_list')}
        </Text.Normal>

        <Box onClick={() => setOpen(!open)} paddingTop="s4">
          <Icon.Small icon={open ? 'chevron-up' : 'chevron-down'} color="grey600" />
        </Box>
      </Box>

      {open && (
        <BoxList>
          {types.map((type) => (
            <Item key={type.id} leaveType={type} />
          ))}
        </BoxList>
      )}
    </>
  )
}

export default observer(ArchivedLeaveTypes)
